<!-- http://localhost:8080/#/bilet/gunluksatisraporu -->
<template>
  <div id="app">
        <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Daily-Ticket-Sales-Report') }} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

<!-- MAIL GÖNDER DIALOG -->
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                  <v-layout row wrap>

                  <v-flex xs12 sm6 pt-2 md2>
                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'" v-bind:value="Rapor.BaslangicTarihi" v-model="Rapor.BaslangicTarihi"></tarihcomp>
                  </v-flex>

                  <v-flex xs12 pt-2 sm6 md2>
                    <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'" v-bind:value="Rapor.BitisTarihi" v-model="Rapor.BitisTarihi"></tarihcomp>
                  </v-flex>



                    <v-flex pt-2>
                      <v-layout>
                        <div v-if="load1">
                          <v-btn color="info" @click="getList()" fab small="" dark>
                            <v-icon>search</v-icon>
                          </v-btn>
                        </div>
                        <div v-if="progress">
                          <v-layout pt-3 align-center="">
                            <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                          </v-layout>
                        </div>
                        <v-badge color="white"  :overlap="true">
                            <template v-slot:badge>
                                <v-icon v-if="filtrevarmi" large color="green">
                                        check_circle_outline     
                                </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true"
                                @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                                color="info" fab dark>
                                <v-icon>filter_list</v-icon>
                            </v-btn>

                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                <span>{{ $t('Add-Search-Filter') }}</span>
                            </v-tooltip>

                        </v-badge>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="#66BB6A">
                              <v-toolbar-title> <span class="subheading white--text">
                                  {{ $t('Tickets-Sold') }}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md6>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" :label="$t('Search')"
                                  append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>

                          </v-flex>

                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headerssatis" :rows-per-page-items=[20,100] :items="itemssatis"
                                :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-left">{{ props.item.HavayoluKodu }}</td>
                                  <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                                  <td class="text-xs-left">{{ [props.item.MasrafKodu, props.item.MasrafAdi].filter(x => x).join(' - ') }}</td>
                                  <td class="text-xs-left">{{ props.item.UcusTip }}</td>
                                  <td class="text-xs-left">{{ props.item.Cari.Kod}}</td>
                                  <td class="text-xs-right">{{ props.item.BiletTutari | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.VergiTutari | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.IskontoTutari | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.ServisTutari | moneyformat }}</td>
                                  <td class="text-xs-left">{{ props.item.KomisyonTutar }}</td>
                                  <td class="text-xs-right">{{ props.item.ReserveTutari | moneyformat }}</td>
                                  <td v-if="!simpleMode" class="text-xs-right">{{ props.item.KrediliTutar | moneyformat }}</td>
                                  <td v-if="!simpleMode" class="text-xs-right">{{ props.item.PesinTutar | moneyformat }}</td>
                                  <td v-if="!simpleMode" class="text-xs-right">{{ props.item.KrediKartTutar }}</td>
                                  <td v-if="!simpleMode" class="text-xs-left">{{ props.item.KrediKartNo }}</td>
                                  <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                                  <td class="text-xs-right">{{ props.item.CezaTutari | moneyformat }}</td>

                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                  {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="title black--text font-weight-bold">
                                {{ $t('General-Totals-Tickets-Sold') }}
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout>

                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Ticket-Amount')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Penalty')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Tax-v2')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Reserve') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('With-Credit') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Cash') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('R-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('C-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('F-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.BiletTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.VergiTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.ServisTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.CKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisIc.FKartliTutar | moneyformat }}{{getparabirimi()}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.BiletTutari  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.VergiTutari | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.ServisTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.ReserveTutari  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.KrediliTutar  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{satisDis.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.CKartliTutar | moneyformat }}{{getparabirimi()}}</span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisDis.FKartliTutar  | moneyformat }}{{getparabirimi()}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.BiletTutari  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.VergiTutari | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.IskontoTutari  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.ServisTutari  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.CKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{satisGen.FKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                            <v-card  flat class="black--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-chip color="green"> <span class="subheading white--text"> {{ $t('Sold-Ticket-Totals') }} </span>
                                    </v-chip>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Ticket-Amount')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.BiletTutari}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.BiletTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.BiletTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Penalty')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.CezaTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.CezaTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.CezaTutari  | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Tax-v2')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Reserve') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('With-Credit')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('Cash') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('R-Card-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold">  {{ $t('C-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold">
                                      {{ $t('F-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex v-if="!simpleMode" xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisIc.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex v-if="!simpleMode" xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisDis.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex v-if="!simpleMode" xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{satisGen.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                              </v-layout>

                            </v-card>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <br />
                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="red">
                              <v-toolbar-title> <span class="subheading white--text">
                                {{this.$t('Returned-Tickets')}}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md6>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchiadebilet" :label="$t('Search')"
                                  append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headerssatis" :rows-per-page-items=[20,100] :items="itemsiade"
                                :search="searchiadebilet">
                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-right">{{ props.item.HavayoluKodu }}</td>
                                  <td class="text-xs-right">{{ props.item.BiletNo }}</td>
                                  <td class="text-xs-left">{{ [props.item.MasrafKodu, props.item.MasrafAdi].filter(x => x).join(' - ') }}</td>
                                  <td class="text-xs-right">{{ props.item.UcusTip }}</td>
                                  <td class="text-xs-right">{{ props.item.Cari.Kod}}</td>
                                  <td class="text-xs-right">{{ props.item.BiletTutari}}</td>
                                  <td class="text-xs-right">{{ props.item.VergiTutari}}</td>
                                  <td class="text-xs-right">{{ props.item.IskontoTutari}}</td>
                                  <td class="text-xs-right">{{ props.item.ServisTutari }}</td>
                                  <td class="text-xs-right">{{ props.item.ReserveTutari }}</td>
                                  <td v-if="!simpleMode" class="text-xs-right">{{ props.item.KrediliTutar }}</td>
                                  <td v-if="!simpleMode" class="text-xs-right">{{ props.item.PesinTutar }}</td>
                                  <td v-if="!simpleMode" class="text-xs-right">{{ props.item.KrediKartTutar }}</td>
                                  <td v-if="!simpleMode" class="text-xs-right">{{ props.item.KrediKartNo }}</td>
                                  <td class="text-xs-right">{{ props.item.FaturaNo }}</td>
                                  <td class="text-xs-right">{{ props.item.CezaTutari }}</td>

                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                   {{ $t('No-records-searched-for', { value: searchiadebilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="title black--text font-weight-bold">
                                {{$t('Sums-of-Refunded-Tickets')}}
                              </span>
                            </v-layout>
                          </v-flex>


                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout>

                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Ticket-Amount')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Penalty')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Tax-v2')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Reserve') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('With-Credit')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Cash')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('R-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('C-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                     {{ $t('F-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{$t('Domestic-Line')}}:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.BiletTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.VergiTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.ServisTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.CKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeic.FKartliTutar | moneyformat }}{{getparabirimi()}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.BiletTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.VergiTutari | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.ServisTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{iadeDis.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.CKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeDis.FKartliTutar | moneyformat }}{{getparabirimi()}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.BiletTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.VergiTutari | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.ServisTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.CKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{iadeGen.FKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>


                          <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-chip color="red"> <span class="subheading white--text"> {{$t('Sums-of-Refunded-Tickets')}}</span>
                                    </v-chip>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Ticket-Amount')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.BiletTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.BiletTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.BiletTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Penalty')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.CezaTutari  | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.CezaTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.CezaTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Tax-v2')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Reserve') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('With-Credit')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold">  {{ $t('Cash') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('R-Card-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('C-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold">
                                      {{ $t('F-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeic.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex v-if="!simpleMode" xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeDis.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex  v-if="!simpleMode" xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{iadeGen.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>


                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>




                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>


                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="#FF9100">
                              <v-toolbar-title> <span class="subheading white--text">
                                  {{ $t('Void') }}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md6>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchvoid" :label="$t('Search')"
                                  append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm12>
                            <v-card flat >
                              <v-data-table :headers="headervoid" :rows-per-page-items=[20,100] :items="itemsvoid"
                                :search="searchvoid">

                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-left">{{ props.item.HavayoluKodu }}</td>
                                  <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                                  <td class="text-xs-left">{{ props.item.UcusTip }}</td>
                                  <td class="text-xs-left">{{ $t('This-ticket-has-been-void') }}</td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                               
                                {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }} 

                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  &nbsp;
                </v-flex>

                <v-flex xs12 sm12 md12 pa-1>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="info">
                              <v-toolbar-title> <span class="subheading white--text">
                                 {{ $t('Grand-Total') }}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>

                            </v-toolbar>

                          </v-flex>
                               <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout>

                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Ticket-Amount')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Penalty')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Tax-v2')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Reserve') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('With-Credit')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Cash')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('R-Card') }} 
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('C-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('F-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{$t('Domestic-Line')}}:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.BiletTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.VergiTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.ServisTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.CKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{genic.FKartliTutar | moneyformat }}{{getparabirimi()}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.BiletTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.VergiTutari | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.ServisTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{gendis.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.CKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gendis.FKartliTutar | moneyformat }}{{getparabirimi()}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.BiletTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.CezaTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.VergiTutari | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.ServisTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.PesinTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.CKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex  v-if="!simpleMode" xs1 sm1 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{gengen.FKartliTutar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>


                          <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                            <v-card class="black--text">
                              <v-layout row wrap>


                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Ticket-Amount')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.BiletTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.BiletTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.BiletTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Penalty')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.CezaTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.CezaTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.CezaTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Tax-v2')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.VergiTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.IskontoTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.ServisTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('Reserve') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.ReserveTutari | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex v-if="!simpleMode" xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{$t('With-Credit')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.KrediliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold">  {{ $t('Cash') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.PesinTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('R-Card-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.RKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold"> {{ $t('C-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} : 
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.CKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading black--text font-weight-bold">
                                      {{ $t('F-Card') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Domestic-Line')}}:
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{genic.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{ $t('International-Line') }} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gendis.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="subheading font-weight-">
                                          {{$t('Total')}} :
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="subheading font-weight-thin">
                                          {{gengen.FKartliTutar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                              </v-layout>

                            </v-card>
                          </v-flex>


                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
            :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="730px">
            <v-card flat color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm6 md6 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <v-text-field hide-details="" v-model="Rapor.KesenKisi" :label="$t('Ticket-Agent')"></v-text-field>
                              <cariaracomp v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="Rapor.Cari.Kod" v-model="Rapor.Cari.Kod"></cariaracomp>
                  
                            <v-autocomplete hide-details="" tabindex="2" v-model="Rapor.Havayolu.HavaYoluKodu" :items="itemsairlinelist"
                              clearable item-text="Title" item-value="HavaYoluKodu" :label="$t('Airline-Code')"></v-autocomplete>

                            <cariaracomp v-bind:etiket="$t('Main-Account')" v-bind:value="Rapor.AnaHesap" v-model="Rapor.AnaHesap"></cariaracomp>

                            <v-select :items="hesapgurubu" hide-details="" v-model="Rapor.HesapGrubu" :label="$t('Account-Group')"
                              item-text="Title" item-value="Kod" max-height="400"></v-select>

                            <v-select hide-details="" :items="doviztipi" v-model="Rapor.Doviz.DovizKod" clearable
                              item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-select>

                            <v-text-field hide-details="" v-model="Rapor.AcentaKodu" :label="$t('Agency-Code')"></v-text-field>

                            <v-text-field hide-details="" v-model="Rapor.FiyatTuru" :label="$t('Price-Type')"></v-text-field>

                            <v-autocomplete hide-details="" v-model="Rapor.Masraf.Code" :items="masrafmerkezi" :label="$t('Expense-Center-v2')"
                              item-text="Title" clearable item-value="Code" max-height="400"></v-autocomplete>

                            <v-text-field hide-details="" v-model="Rapor.DepatmanKodu" label="Depertman Kodu"></v-text-field>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                  <v-flex xs12 sm6 md6 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <v-checkbox v-model="Rapor.Opsiyonlar.IadeFatDekont" :label="$t('Show-Receipt-No-Invoice-No')"
                              hide-details=""></v-checkbox>
                            <v-checkbox :label="$t('Show-Commission-Amount')" v-model="Rapor.Opsiyonlar.KomisyonGoster" hide-details=""></v-checkbox>
                            <v-checkbox :label="$t('Show-Tickets-in-Temporary-Account')" v-model="Rapor.Opsiyonlar.GeciciHesap" hide-details=""></v-checkbox>
                            <v-checkbox label="Degişken Alanı Karda Göster" v-model="Rapor.Opsiyonlar.ReserveTutariKardaGoster" hide-details=""></v-checkbox>
                            
                            <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-card flat="" color="#9E9E9E">
                      <v-card-title>
                        <span class="subheading white--text font-weight-medium ">Opisyonlar</span>
                      </v-card-title>
                    </v-card>


                  </v-flex>

                  <div class="flex md3">
                    <v-radio-group :label="$t('Sort-By')" v-model="Rapor.Opsiyonlar.SiraTip" hide-details>
                      <v-radio value="0" :label="$t('Ticket-No')"></v-radio>
                      <v-radio value="1" :label="$t('Customer-Code')"></v-radio>
                      <v-radio value="2" :label="$t('Daily-Total')"></v-radio>
                    </v-radio-group>
                  </div>
                  <div class="flex md3">
                    <v-radio-group :label="$t('Report-Type')" v-model="Rapor.Opsiyonlar.RaporTip" hide-details>
                      <v-radio value="0" :label="$t('All')"></v-radio>
                      <v-radio value="1" :label="$t('Sales')"></v-radio>
                      <v-radio value="2" :label="$t('Refund')"></v-radio>
                      <v-radio value="3" :label="$t('Void')"></v-radio>
                    </v-radio-group>
                  </div>

                  <div class="flex md3">
                    <v-radio-group :label="$t('Line-Type')" v-model="Rapor.Opsiyonlar.HatTip" hide-details>
                      <v-radio value="0" :label="$t('All')"></v-radio>
                      <v-radio value="1" :label="$t('Domestic-Line')"></v-radio>
                      <v-radio value="2" :label="$t('International-Line')"></v-radio>

                    </v-radio-group>
                  </div>

                  <div class="flex md3">

                    <v-radio-group :label="$t('Payment-Type')" v-model="Rapor.Opsiyonlar.OdemeTip" hide-details>
                      <v-radio value="0" :label="$t('All')"></v-radio>
                      <v-radio value="1" :label="$t('With-Credit')"></v-radio>
                      <v-radio value="2" :label="$t('Cash')"></v-radio>
                      <v-radio value="3" :label="$t('Credit-Card')"></v-radio>

                    </v-radio-group>
                  </div>

                  <div class="flex md3">
                    <v-radio-group :label="'TL/'+ $t('Currency')"  v-model="Rapor.Opsiyonlar.DovizTl" hide-details>
                      <v-radio :value="false" label="TL"></v-radio>
                      <v-radio :value="true" :label="$t('Currency')"></v-radio>
                    </v-radio-group>
                  </div>
                  <div class="flex md3">
                    <v-radio-group :label="$t('Details')+ '/' + $t('Summary')" v-model="Rapor.Opsiyonlar.DetayOzet" hide-details>
                      <v-radio :value="false" :label="$t('Details')"></v-radio>
                      <v-radio :value="true" :label="$t('Summary')"></v-radio>
                    </v-radio-group>
                  </div>

                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'


  export default {
    data() {
      return {
        simpleMode: false,
        mailDialog: false,
mailValid: false,
mailLoading: false,
mailPayload: {
  To: "",
  AgencyName: "",
  DocType: "Bilet Günlük Satış Raporu - Daily Ticket Sales Report", 
  AgentFullName: "",
  CustomBody: ""
},
rules: {
  required: v => !!v || 'Zorunlu alan',
  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
},
        PB:'TRY',
          sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi:false,
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        satisIc: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisDis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisGen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },
        iadeic: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,
        },

        iadeDis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        iadeGen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        genic: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,
        },

        gendis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        gengen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },
        Rapor: {
          SirketKodu: null,
          KesenKisi: null,
          Cari: {
            Kod: null,
          },
          Havayolu: {
            HavaYoluKodu: null,
            FormNo: null,
            HavaYoluAdi: null
            //devam eden class
          },
          AnaHesap: null,
          HesapGrubu: null,
          BaslangicTarihi: null,
          BitisTarihi: null,
          Doviz: {
            DovizKod: null
          },
          AcentaKodu: null,
          FiyatTuru: null,
          Masraf: {
            Code: null
          },
          DepatmanKodu: null,
          Opsiyonlar: {
            SiraTip: '0', // 0 : BiletNo, 1 : Musteri Kodu, 2: Gün Toplamlı
            RaporTip: '0', // 0 : Hepsi, 1 : Satis , 2 : Iade, 3 : Void
            HatTip: '0', // 0 : Hepsi , 1 : İç Hat, 2: Dış Hat
            OdemeTip: '0', // 0 : Hepsi, 1 : Kredili , 2 : Pesin , 3 : Kredi Kartlı
            DovizTl: false, // false: tl , true : doviz
            DetayOzet: false, // false : detay , true : ozet
            KesimTarihi: false,
            GeciciHesap: false,
            IadeFatDekont: false, // Iade fatura : false, Dekont : true;
            KomisyonGoster:false,
            ReserveTutariKardaGoster:false,

          }
        },
        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        tumsirketler: '',
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],
        itemsvoid: [],
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {

        this.simpleModeYukle();

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi

      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

       if (this.sayfayetki.Status != true) {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var mainUrl = '#/'
              window.open(mainUrl, '_self')
            }
          } 

        });
      } 
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      yetkidialog,
      cariaracomp
    },
    watch: {
    },
    methods: {
      simpleModeYukle() {
  var manageload = null;

  try {
    manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
  } catch (e) {
    manageload = null;
  }

  if (manageload && manageload.UserInfo) {
    this.simpleMode =
      manageload.UserInfo.SimpleMode === true ||
      manageload.UserInfo.SimpleMode === 1 ||
      manageload.UserInfo.SimpleMode === "1" ||
      manageload.UserInfo.SimpleMode === "true";
  }
},
      openMailDialog() {
  if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.reset) {
    this.$refs.mailForm.reset();
  }
  
  if (!this.mailPayload) this.mailPayload = {};
  if (!this.mailPayload.DocType) {
    this.mailPayload.DocType = "Günlük Satış Raporu - Daily Ticket Sales Report";
  }
  this.mailDialog = true;
},

closeMailDialog() {
  this.mailDialog = false;
},

sendMail() {
  var _this = this;

  if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {
    return;
  }

  var bas = _this.Rapor && _this.Rapor.BaslangicTarihi ? new Date(_this.Rapor.BaslangicTarihi) : null;
  var bit = _this.Rapor && _this.Rapor.BitisTarihi     ? new Date(_this.Rapor.BitisTarihi)     : null;
  if (!(bas && bit) || bas > bit) {
    _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');
    _this.snackbar = true;
    return;
  }

  var credentialsRaw = window.localStorage.getItem('credentials');
  var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
  var companyCode = _this.tumsirketler === true ? '0'
                    : (credentials && credentials.SirketKodu) ? credentials.SirketKodu
                    : null;

  var opsiyonlar = {
    GeciciHesap:      !!(_this.Rapor && _this.Rapor.GeciciHesap),
    HatTipi:          (_this.Rapor && typeof _this.Rapor.HatTipi     !== 'undefined') ? _this.Rapor.HatTipi     : 0,
    SatisTipi:        (_this.Rapor && typeof _this.Rapor.SatisTipi   !== 'undefined') ? _this.Rapor.SatisTipi   : 0,
    OdemeTipi:        (_this.Rapor && typeof _this.Rapor.OdemeTipi   !== 'undefined') ? _this.Rapor.OdemeTipi   : 0,
    ClassTip:         (_this.Rapor && _this.Rapor.ClassTip) || null,
    BiletYon:         (_this.Rapor && typeof _this.Rapor.BiletYon    !== 'undefined') ? _this.Rapor.BiletYon    : 0,
    CrsTip:           (_this.Rapor && _this.Rapor.CrsTip) || null,
    Efaturali:        !!(_this.Rapor && _this.Rapor.Efaturali),
    Siralama:         (_this.Rapor && typeof _this.Rapor.Siralama    !== 'undefined') ? _this.Rapor.Siralama    : 0,
    IadeSatisSifirla: !!(_this.Rapor && _this.Rapor.IadeSatisSifirla)
  };

  
  var cariKod     = (_this.Rapor && (_this.Rapor.CariKod || (_this.Rapor.Cari && _this.Rapor.Cari.Kod))) || null;
  var dovizKod    = (_this.Rapor && _this.Rapor.DovizKod)     || null;
  var masrafKod   = (_this.Rapor && _this.Rapor.MasrafKodu)   || null;
  var havKodu     = (_this.Rapor && _this.Rapor.HavayoluKodu) || null;
  var havFormNo   = (_this.Rapor && _this.Rapor.FormNo)       || null;
  var havAdi      = (_this.Rapor && _this.Rapor.HavayoluAdi)  || null;

  var payload = {
    Input: {
      SirketKodu:      companyCode,
      BaslangicTarihi: _this.Rapor.BaslangicTarihi,
      BitisTarihi:     _this.Rapor.BitisTarihi,

      // alanlar null olabilir
      Cari:     { Kod: cariKod },
      Doviz:    { DovizKod: dovizKod },
      Masraf:   { Code: masrafKod },
      Havayolu: { HavaYoluKodu: havKodu, FormNo: havFormNo, HavaYoluAdi: havAdi },

      Opsiyonlar: opsiyonlar
    },
    Mail: {
      To:            (_this.mailPayload && _this.mailPayload.To)            ? _this.mailPayload.To            : "",
      AgencyName:    (_this.mailPayload && _this.mailPayload.AgencyName)    ? _this.mailPayload.AgencyName    : "",
      DocType:       (_this.mailPayload && _this.mailPayload.DocType)       ? _this.mailPayload.DocType       : "Bilet Günlük Satış Raporu - Daily Ticket Sales Report",
      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",
      CustomBody:    (_this.mailPayload && _this.mailPayload.CustomBody)    ? _this.mailPayload.CustomBody    : ""
    }
  };

  _this.mailLoading = true;
  _this.$http.post(
    auth.API_URL + 'api/TicketReport/MailGonderDailySalesExcel',
    payload,
    { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
  ).then(function () {
      _this.mailLoading = false;
      _this.mailDialog = false;
      _this.text1 = 'Mail gönderildi.';
      _this.snackbar = true;
    }, function (err) {
      _this.mailLoading = false;
      var body = err && (err.body || err.data || {});
      var msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';
      _this.text1 = msg;
      _this.snackbar = true;
    }
  );
},


      getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
    computed:{
        headerssatis() {
            return [{
            text: 'HY',
            value: 'HavayoluKodu',
            width: "5%",
            align: 'left'
          },
          {
            text: this.$t('Ticket-No'),
            value: 'BiletNo',
            width: "10%",
            align: 'left'
          },
           {
            text: this.$t('Cost-Center-Code'),
            value: 'MasrafKodu',
            width: "10%",
            align: 'left'
          },
          {
            text: this.$t('Flight-Type'),
            value: 'UcusTip',
            width: "5%",
            align: 'left'
          },
          {
            text: this.$t('Account'),
            value: 'Cari.Kod',
            width: "10%",
            align: 'left'
          },
          {
            text: this.$t('Ticket-Amount'),
            value: 'BiletTutari',
            width: "10%",
            align: 'left'
          },
          {
            text: this.$t('Tax-v2'),
            value: 'VergiTutari',
            width: "10%",
            align: 'left'
          },
          {
            text: this.$t('Discount'),
            value: 'IskontoTutari',
            width: "1%",
            align: 'left'
          },
          {
            text: this.$t('Service'),
            value: 'ServisTutari',
            width: "10%",
            align: 'left'
          },

          {
            text: this.$t('Commission'),
            value: 'KomisyonTutar',
            width: "10%",
            align: 'left'
          },
          {
            text: this.$t('Reserve'),
            value: 'ReserveTutari',
            width: "10%",
            align: 'left'
          },
          {
            text: this.$t('With-Credit'),
            value: 'KrediliTutar',
            width: "10%",
            align: 'left',
            simpleHide: true
          },
          {
            text: this.$t('Cash'),
            value: 'PesinTutar',
            width: "10%",
            align: 'left',
            simpleHide: true
          },
          {
            text: this.$t('With-Credit-Card'),
            value: 'KrediKartTutar',
            width: "10%",
            align: 'left',
            simpleHide: true
          },
          {
            text: this.$t('Credit-Card-No'),
            value: 'KrediKartNo',
            width: "10%",
            align: 'left',
            simpleHide: true
          },
          {
            text: this.$t('Invoice-No'),
            value: 'FaturaNo',
            width: "0%",
            align: 'left'
          },
          {
            text: this.$t('Penalty'),
            value: 'CezaTutari',
            width: "0%",
            align: 'left'
          }
        ].filter(x => !(this.simpleMode && x.simpleHide))
        },
        headervoid(){
          return [{
            text: 'HY',
            value: 'HavayoluKodu'
          },
          {
            text: this.$t('Ticket-No'),
            value: 'BiletNo'
          },
          {
            text: this.$t('Flight-Type'),
            value: 'UcusTip'
          },
          {
            text: this.$t('Description'),
            value: ''
          }

        ]
        },
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      }
    })
  }

  function filtrekayit() {
    this.filtrevarmi=true
    this.dialogfiltre = false
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi=false
    this.dialogfiltre = false
    this.Rapor.SirketKodu = null
    this.Rapor.KesenKisi = null
    this.Rapor.Cari.Kod = null
    this.Rapor.Havayolu.HavaYoluKodu = null
    this.Rapor.AnaHesap = null
    this.Rapor.HesapGrubu = null
    this.Rapor.Doviz.DovizKod = null
    this.Rapor.AcentaKodu = null
    this.Rapor.FiyatTuru = null
    this.Rapor.Masraf.Code = null
    this.Rapor.DepatmanKodu = null
    this.Rapor.Opsiyonlar.SiraTip ="0"
    this.Rapor.Opsiyonlar.RaporTip = "0"
    this.Rapor.Opsiyonlar.OdemeTip = "0"
     this.Rapor.Opsiyonlar.HatTip = "0"
    this.Rapor.Opsiyonlar.DovizTl =false
    this.Rapor.Opsiyonlar.DetayOzet = false
    this.Rapor.Opsiyonlar.KesimTarihi = false
    this.Rapor.Opsiyonlar.GeciciHesap = false
    this.Rapor.Opsiyonlar.IadeFatDekont = false
    this.Rapor.Opsiyonlar.ReserveTutariKardaGoster=false
  }


  
  function getList() {

    
    if (this.satisIc!=null)
    {
      this.satisIc.BiletTutari=0;
    this.satisIc.CezaTutari=0;
    this.satisIc.VergiTutari=0;
    this.satisIc.IskontoTutari=0;
    this.satisIc.ServisTutari=0;
    this.satisIc.IadeServisTutari=0;
    this.satisIc.ReserveTutari=0;
    this.satisIc.KrediliTutar=0;
    this.satisIc.PesinTutar=0;
    this.satisIc.RKartliTutar=0;
    this.satisIc.CKartliTutar=0;
    this.satisIc.FKartliTutar=0;

    this.satisDis.BiletTutari=0;
    this.satisDis.CezaTutari=0;
    this.satisDis.VergiTutari=0;
    this.satisDis.IskontoTutari=0;
    this.satisDis.ServisTutari=0;
    this.satisDis.IadeServisTutari=0;
    this.satisDis.ReserveTutari=0;
    this.satisDis.KrediliTutar=0;
    this.satisDis.PesinTutar=0;
    this.satisDis.RKartliTutar=0;
    this.satisDis.CKartliTutar=0;
    this.satisDis.FKartliTutar=0;

    this.gengen.BiletTutari=0;
    this.gengen.CezaTutari=0;
    this.gengen.VergiTutari=0;
    this.gengen.IskontoTutari=0;
    this.gengen.ServisTutari=0;
    this.gengen.IadeServisTutari=0;
    this.gengen.ReserveTutari=0;
    this.gengen.KrediliTutar=0;
    this.gengen.PesinTutar=0;
    this.gengen.RKartliTutar=0;
    this.gengen.CKartliTutar=0;
    this.gengen.FKartliTutar=0;

    this.gendis.BiletTutari=0;
    this.gendis.CezaTutari=0;
    this.gendis.VergiTutari=0;
    this.gendis.IskontoTutari=0;
    this.gendis.ServisTutari=0;
    this.gendis.IadeServisTutari=0;
    this.gendis.ReserveTutari=0;
    this.gendis.KrediliTutar=0;
    this.gendis.PesinTutar=0;
    this.gendis.RKartliTutar=0;
    this.gendis.CKartliTutar=0;
    this.gendis.FKartliTutar=0;

    this.genic.BiletTutari=0;
    this.genic.CezaTutari=0;
    this.genic.VergiTutari=0;
    this.genic.IskontoTutari=0;
    this.genic.ServisTutari=0;
    this.genic.IadeServisTutari=0;
    this.genic.ReserveTutari=0;
    this.genic.KrediliTutar=0;
    this.genic.PesinTutar=0;
    this.genic.RKartliTutar=0;
    this.genic.CKartliTutar=0;
    this.genic.FKartliTutar=0;

    this.iadeGen.BiletTutari=0;
    this.iadeGen.CezaTutari=0;
    this.iadeGen.VergiTutari=0;
    this.iadeGen.IskontoTutari=0;
    this.iadeGen.ServisTutari=0;
    this.iadeGen.IadeServisTutari=0;
    this.iadeGen.ReserveTutari=0;
    this.iadeGen.KrediliTutar=0;
    this.iadeGen.PesinTutar=0;
    this.iadeGen.RKartliTutar=0;
    this.iadeGen.CKartliTutar=0;
    this.iadeGen.FKartliTutar=0;

    this. iadeDis.BiletTutari=0;
    this.iadeDis.CezaTutari=0;
    this.iadeDis.VergiTutari=0;
    this.iadeDis.IskontoTutari=0;
    this.iadeDis.ServisTutari=0;
    this.iadeDis.IadeServisTutari=0;
    this.iadeDis.ReserveTutari=0;
    this.iadeDis.KrediliTutar=0;
    this.iadeDis.PesinTutar=0;
    this.iadeDis.RKartliTutar=0;
    this.iadeDis.CKartliTutar=0;
    this.iadeDis.FKartliTutar=0;

    this.iadeic.BiletTutari=0;
    this.iadeic.CezaTutari=0;
    this.iadeic.VergiTutari=0;
    this.iadeic.IskontoTutari=0;
    this.iadeic.ServisTutari=0;
    this.iadeic.IadeServisTutari=0;
    this.iadeic.ReserveTutari=0;
    this.iadeic.KrediliTutar=0;
    this.iadeic.PesinTutar=0;
    this.iadeic.RKartliTutar=0;
    this.iadeic.CKartliTutar=0;
    this.iadeic.FKartliTutar=0;

    this.satisGen.BiletTutari=0;
    this.satisGen.CezaTutari=0;
    this.satisGen.VergiTutari=0;
    this.satisGen.IskontoTutari=0;
    this.satisGen.ServisTutari=0;
    this.satisGen.IadeServisTutari=0;
    this.satisGen.ReserveTutari=0;
    this.satisGen.KrediliTutar=0;
    this.satisGen.PesinTutar=0;
    this.satisGen.RKartliTutar=0;
    this.satisGen.CKartliTutar=0;
    this.satisGen.FKartliTutar=0;
    }
    
    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false




        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/DailySalesReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {


          this.itemssatis = response.body.SatisBilgi.Detay
          this.itemsiade = response.body.IadeBilgi.Detay
          this.itemsvoid = response.body.VoidBilgi.Detay
          console.log(response.body.VoidBilgi.Detay)

          this.satisIc = response.body.SatisBilgi.ToplamIcHat
          this.satisDis = response.body.SatisBilgi.ToplamDisHat
          this.satisGen = response.body.SatisBilgi.ToplamGenel



          if (response.body.IadeBilgi.Detay.length > 0) {
            this.iadeic = response.body.IadeBilgi.ToplamIcHat
            this.iadeDis = response.body.IadeBilgi.ToplamDisHat
            this.iadeGen = response.body.IadeBilgi.ToplamGenel
          }


          this.genic = response.body.IchatToplamlar
          this.gendis = response.body.DisHatToplamlar
          this.gengen = response.body.GenelToplamlar



          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {


    this.progress = true
    this.load1 = false




    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var lang = localStorage.getItem('lang')
    if (this.tumsirketler === true) {
      this.Rapor.SirketKodu = '0'
    } else {
      this.Rapor.SirketKodu = credentials.SirketKodu
    }


    var params = this.Rapor
    this.$http
      .post(auth.API_URL + "api/TicketReport/DailySalesHtmlReport", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        if (lang=='en')
{
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> GÜNLÜK SATIŞ RAPORU </title>','<title> DAILY SALES REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>GÜNLÜK SATIŞ RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>DAILY SALES REPORT</font>");
             bodyhtml=bodyhtml.toString().replace("Seçenekler :","Options :");
             bodyhtml=bodyhtml.toString().replace("Fiyat Türü :","Price Type :");
             bodyhtml=bodyhtml.toString().replace("Seçenekler :	","Options :");
             bodyhtml=bodyhtml.toString().replace("Kesen Kişi :","Person Issuing Tickets :");
             bodyhtml=bodyhtml.toString().replace("Hesap Grubu :","Account Group :");
             bodyhtml=bodyhtml.toString().replaceAll("Bilet No","Ticket No");
             bodyhtml=bodyhtml.toString().replaceAll("Bilet Amountı","Ticket Amount");
             bodyhtml=bodyhtml.toString().replace("Hesap","Account");
             bodyhtml=bodyhtml.toString().replaceAll("Vergi","Tax");
             bodyhtml=bodyhtml.toString().replaceAll("İskonto","Discount");
             bodyhtml=bodyhtml.toString().replaceAll("Kredili","With Credit");
             bodyhtml=bodyhtml.toString().replaceAll("Peşin","Cash");
             bodyhtml=bodyhtml.toString().replaceAll("Fatura No","Invoice No");
             bodyhtml=bodyhtml.toString().replaceAll("Ceza","Penalty");
             bodyhtml=bodyhtml.toString().replaceAll("Yolcu Name","Passanger Name");
             bodyhtml=bodyhtml.toString().replaceAll("Servis","Service")
             bodyhtml=bodyhtml.toString().replaceAll("Bilet Tutarı","Ticket Amount")
             bodyhtml=bodyhtml.toString().replaceAll("SATIŞ TOTALS","SALES TOTALS")
             bodyhtml=bodyhtml.toString().replaceAll("İade Service","Return Service")
             bodyhtml=bodyhtml.toString().replaceAll("R-Kredi Kartlı","R-With Credit Card")
             bodyhtml=bodyhtml.toString().replaceAll("C-Kredi Kartlı","C-With Credit Card")
             bodyhtml=bodyhtml.toString().replaceAll("Hesap","Account")
             bodyhtml=bodyhtml.toString().replaceAll("İç Hat :","Domestic line :")
             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat :","International line :")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam :","Total :")
             bodyhtml=bodyhtml.toString().replace("SATILAN BİLETLER","TICKETS SOLD");
             bodyhtml=bodyhtml.toString().replace("İADE EDİLEN BİLETLER","REFUNDED TICKETS");
             bodyhtml=bodyhtml.toString().replace("VOİD BİLETLER","VOID TICKETS");
             bodyhtml=bodyhtml.toString().replace("KAR TOPLAMLARI"," PROFIT TOTALS")
             bodyhtml=bodyhtml.toString().replace("TOPLAMLAR","TOTALS")
             bodyhtml=bodyhtml.toString().replace("İADE TOPLAMLAR","REFUND TOTALS")
             bodyhtml=bodyhtml.toString().replace("NET TOPLAMLAR","NET TOTALS")
             bodyhtml=bodyhtml.toString().replaceAll("Bu bilet void olmuştur","This ticket has been void")
             bodyhtml=bodyhtml.toString().replaceAll("Kredi Kartlı","With C.C")
             bodyhtml=bodyhtml.toString().replaceAll("Service Matrah","Service Base")
             bodyhtml=bodyhtml.toString().replaceAll("Komisyon","Commission")
             bodyhtml=bodyhtml.toString().replaceAll("Service Kdv","Service Vat")
             bodyhtml=bodyhtml.toString().replaceAll("Kredi Kart No","Credit Card No")
             bodyhtml=bodyhtml.toString().replaceAll("Bilet no sıralı;","Ticket No")
             bodyhtml=bodyhtml.toString().replaceAll("Satış tarihine göre;","By sales date")
             bodyhtml=bodyhtml.toString().replaceAll("TOPLAMLAR","TOTALS")
             bodyhtml=bodyhtml.toString().replaceAll("İç Hat Totalları :","Domestic Lines Totals :")
             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat Toplamları :","International Lines Totals :")
             bodyhtml=bodyhtml.toString().replaceAll("Iade Toplamları :","Refund Totals :")
             bodyhtml=bodyhtml.toString().replaceAll("TOPLAM :","TOTAL :")
             
             response.bodyText=bodyhtml;
             console.log(bodyhtml);
          }
        var blob = new Blob([response.bodyText], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.$t('GunSatis') + ".html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
  }


  function getListExcel() {

    this.progress = true
    this.load1 = false




    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.Rapor.SirketKodu = '0'
    } else {
      this.Rapor.SirketKodu = credentials.SirketKodu
    }


    var params = this.Rapor
    this.$http
      .post(auth.API_URL + "api/TicketReport/DailySalesExcelReport", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.$t('GunSatis') + ".xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
  }


  function beforeMount() {

  }
</script>
<style>
</style>